import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$plan_id/showroom" as string,
      params: {
        builder_id: params.builder_id,
        master_plan_id: params.master_plan_id,
        community_id: params.community_id,
        plan_id: params.plan_id,
      } as Record<string, string>,
      statusCode: 301,
    });
  },
});
